import Vue from 'vue'
import { uuid } from '@/lib'
import * as action from '../action-types'
import * as mutation from '../mutation-types'

export const state = {
  datasets: []
}

export const getters = {
  datasets: state => () =>
    state.datasets,

  dataset: state => datasetId => {
    return state.datasets.find(d => d.datasetId === datasetId)
  },

  datasetColumns: state => datasetId => {
    return (state.datasets.find(d => d.datasetId === datasetId) || {}).columns || []
  },

  datasetRecord: state => (datasetId, recordId) => {
    return ((state.datasets.find(d => d.datasetId === datasetId) || {}).records || [])
      .find(each => each.recordId === recordId)
  },

  datasetRecords: state => datasetId => {
    return (state.datasets.find(d => d.datasetId === datasetId) || {}).records || []
  }
}

export const actions = {
  [action.DATASET_CREATE] ({commit, dispatch}, {datasetId, componentType, name, dataUrl, columns, records}) {
    datasetId = datasetId || uuid()
    componentType = componentType || 'dataset-window'
    name = name || 'Unnamed Dataset'
    commit(mutation.DATASET_CREATE, {
      datasetId,
      componentType,
      name,
      fileName: dataUrl,
      columns,
      records,
      emit: true
    })
    dispatch(action.WINDOW_CREATE, {
      componentType,
      title: name,
      data: {datasetId, contentId: datasetId}
    })
  },

  [action.DATASET_OPEN] ({getters, dispatch}, {datasetId}) {
    const dataset = getters.dataset(datasetId)
    if (!dataset) return
    dispatch(action.WINDOW_OPEN_CREATE, {
      componentType: dataset.componentType || 'dataset-window',
      title: dataset.name,
      contentId: datasetId
    })
  },

  [action.DATASET_DELETE] ({commit, getters}, {datasetId}) {
    const window = getters.windowByContentId(datasetId)
    if (window) {
      commit(mutation.WINDOW_DELETE, {
        windowId: window.windowId,
        emit: true
      })
    }
    commit(mutation.DATASET_DELETE, {
      datasetId,
      emit: true
    })
  }
}

export const mutations = {
  [mutation.DATASET_STATE] (state, datasets) {
    datasets = Array.isArray(datasets) ? datasets : (typeof datasets === 'object' ? [datasets] : [])
    state.datasets = datasets.map(ds => {
      ds.datasetId = ds.datasetId || uuid()
      ds.name = ds.name || 'Unnamed Dataset'
      ds.fileName = ds.fileName || null
      ds.columns = ds.columns || []
      ds.records = ds.records || []
      return ds
    })
  },
  [mutation.DATASET_CREATE] (state, {datasetId, name, componentType, fileName, columns, records}) {
    const idx = state.datasets.findIndex(d => d.datasetId === datasetId)
    if (idx >= 0) return
    state.datasets.push({datasetId, name, componentType, fileName, columns: columns || [], records: records || []})
  },
  [mutation.DATASET_DELETE] (state, {datasetId}) {
    const idx = state.datasets.findIndex(d => d.datasetId === datasetId)
    if (idx < 0) return
    state.datasets.splice(idx, 1)
  },
  [mutation.DATASET_UPDATE_META] (state, {datasetId, name, fileName, columns}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return
    dataset.name = name || dataset.name
    dataset.fileName = fileName || dataset.fileName
    dataset.columns = columns || dataset.columns
  },
  [mutation.DATASET_CREATE_RECORD] (state, {datasetId, record}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return
    dataset.records.push(record)
  },
  [mutation.DATASET_DELETE_RECORD] (state, {datasetId, recordId}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return
    const idx = dataset.records.findIndex(r => r.recordId === recordId)
    if (idx < 0) return
    dataset.records.splice(idx, 1)
  },
  [mutation.DATASET_UPDATE_RECORD] (state, {datasetId, record}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return
    const idx = dataset.records.findIndex(r => r.recordId === record.recordId)
    if (idx < 0) return
    Vue.set(dataset.records, idx, record)
  },
  [mutation.DATASET_UPDATE_RECORDS] (state, {datasetId, columns, records}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return
    dataset.columns = columns || dataset.columns
    dataset.records = records
  },

  [mutation.DATASET_UPDATE_VALUE] (state, {datasetId, recordId, column, value}) {
    const dataset = state.datasets.find(d => d.datasetId === datasetId)
    if (!dataset) return console.warn('Dataset not found', datasetId)
    const record = dataset.records.find(r => r.recordId === recordId)
    if (!record) return console.warn('Record not found', recordId)
    // if (!record.hasOwnProperty(column)) return console.warn('Column not found', column, record)
    Vue.set(record, column, value)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/datasets.js